// extracted by mini-css-extract-plugin
export default {"App":"App_App__eUeB5","hw":"App_hw__BYNCy","hwBorder":"App_hwBorder__rkUBg","hwTitle":"App_hwTitle__i41fG"};